// ─── Checkout ─────────────────────────────────────────────────────────────────

export function prepareCheckoutData(apply_balance, balance_discount) {
  return {
    apply_balance,
    balance: apply_balance ? balance_discount : 0
  };
}

// ─── Admin ────────────────────────────────────────────────────────────────────

export function prepareDeclineData(changes) {
  return {
    status: 'changes_required',
    changes
  };
}

export function prepareApproveData() {
  return {
    status: 'published'
  };
}

// ─── Search ───────────────────────────────────────────────────────────────────

export function prepareSimilarProposalsQuery(work_type) {
  return {
    work_types: [work_type]
  };
}

export function filterExcludingProposal(results, uuid) {
  return results.filter((l) => l.uuid !== uuid);
}
